$(document).on('click', '.bn_share', function() {
    let that = $(this);

    $.ajax({
        'url': '/share-social/show',
        'type': 'GET',
        'data': {
            id: that.data('id'),
            type: that.data('type'),
            url: that.data('url'),
        },
        'beforeSend': function () {
            $('#socialModalNew').remove();
        },
        'success': function (response) {
            $('body').append(response)

            shareSocial.shareUpdate();

            if (navigator.share) {
                shareSocial.nativeShare();
            } else {
                window.AndroidShareHandler.share(that.data('url'));
            }
        }
    });
});